import { ApolloLink, Observable } from 'apollo-link';
import { BatchHttpLink } from 'apollo-link-batch-http';
import { Store, get, set } from 'idb-keyval';

export class CachedLink extends ApolloLink {
  constructor({ uri, fetch, storeName }) {
    super();
    this.batcher = new BatchHttpLink({ uri, fetch });
    if (process.browser) {
      this.store = new Store('app', storeName);
    }
  }

  async fromCache(operation) {
    if (process.server) {
      return null;
    }

    try {
      const cachedValue = await get(operation.toKey(), this.store);

      return cachedValue;
    } catch (err) {
      console.error(err.message);
      return null;
    }
  }

  fromNetwork(operation) {
    const operationObs = this.batcher.request(operation);

    return new Promise(resolve => {
      operationObs.subscribe({
        next: async value => {
          try {
            if (process.browser) {
              await set(operation.toKey(), value, this.store);
            }
          } catch (err) {
            console.error(err.message);
          }

          resolve(value);
        }
      });
    });
  }

  request(operation) {
    return new Observable(async observer => {
      const cacheValue = await this.fromCache(operation);

      if (process.browser && !window.navigator.onLine && cacheValue) {
        operation.setContext({ response: cacheValue });
        observer.next(cacheValue);
        observer.complete();

        return cacheValue;
      }

      const freshValue = await this.fromNetwork(operation);
      observer.next(freshValue);
      observer.complete();
    });
  }
}
